<div class="app-container">
  <header class="navbar" *ngIf="!isAdminRoute()">
    <nav-bar></nav-bar>
  </header>
  <main [ngClass]="isAdminRoute() ? 'admin-content' : 'content'">
    <div
      [ngClass]="isAdminRoute() ? 'admin-container' : 'responsive-container'"
    >
      <app-loading></app-loading>
      <router-outlet></router-outlet>
    </div>
  </main>
  <footer class="footer">
    <footer></footer>
  </footer>
</div>
